import { IImageOrIconElement } from '@faire/web-api--source/indigofair/data/IImageOrIconElement';
import { ISlateTextStyle } from '@faire/web-api--source/indigofair/data/ISlateTextStyle';

export namespace ISlateTextElement {
  /**
   * Return an instance of ISlateTextElement with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ISlateTextElement>
  ): ISlateTextElement =>
    ({
      ...(partial ?? {}),
    }) as ISlateTextElement;
}

/**
 * DEPRECATED, please use a SlateText. For adding prefix and
 * suffix images, combine SlateIcon(s) with SlateText
 * @deprecated
 */
export interface ISlateTextElement {
  style: ISlateTextStyle | undefined;
  text: string | undefined;
  suffix_image_or_icon_element: IImageOrIconElement | undefined;
  prefix_image_or_icon_element: IImageOrIconElement | undefined;
}
